<template>
  <div>
    <!-- Update Status Modal -->
    <div v-if="showStatusModal" class="modal fade show d-block" tabindex="-1" role="dialog" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel">Update Status</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="closeModal('status')">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <section class="row">
              <div class="col-lg-12">
                <Status :module="module" :default="ActionObject.Status.message"/>
              </div>
            </section>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-success btn-flat" @click="submitStatusModal">Confirm</button>
            <button type="button" class="btn btn-secondary btn-flat" @click="closeModal('status')">Cancel</button>
          </div>
        </div>
      </div>
    </div>
    <!-- Delete Modal -->
    <div v-if="showDeleteModal" class="modal fade show d-block" tabindex="-1" role="dialog" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel">Delete {{toTitleCase(module)}}</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="closeModal('delete')">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            {{toTitleCase(module)}} <strong>{{ this.ActionObject.Name }}<span v-if="this.ActionObject.Company != ''"> - </span>{{ this.ActionObject.Company }}</strong> will be deleted.
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-success btn-flat" @click="submitDeleteModal">Confirm</button>
            <button type="button" class="btn btn-secondary btn-flat" @click="closeModal('delete')">Cancel</button>
          </div>
        </div>
      </div>
    </div>
    <div v-if="showModal" class="modal-backdrop fade show"></div>
  </div>
</template>

<script>
// @ is an alias to /src
import Status from '@/components/form/Status.vue'
import { EventBus } from '@/event-bus.js'

export default {
  name: 'ActionModals',
  components: {
    Status
  },
  props: {
    module: String,
  },
  data() {
    return {
      ActionObject: "",
      showStatusModal: false,
      showDeleteModal: false,
      showModal: false
    }
  },
  computed: {
    
  },
  mounted() {
    // Open Status Modal
    EventBus.$on(['status-action-click'], (data) => {
      this.ActionObject = data;
      this.openModal('status');
    });
    // Open Delete Modal
    EventBus.$on(['delete-action-click'], (data) => {
      this.ActionObject = data;
      this.openModal('delete');
    });
  },
  methods: {
    openModal: function(type) {
      // Open Modal Conditionally
      if (type == "status") {
        this.showStatusModal = true;
      }
      else if (type == "delete") {
        this.showDeleteModal = true;
      }
      // Add Backdrop & Manage Body Scroll
      this.showModal = true;
      this.disableBodyScroll();
    },
    closeModal: function(type) {
      // Close Modal Conditionally
      if (type == "status") {
        this.showStatusModal = false;
      }
      else if (type == "delete") {
        this.showDeleteModal = false;
      }
      // Remove Backdrop & Manage Body Scroll
      this.showModal = false;
      this.enableBodyScroll();
      // Reset Object
      this.ActionObject = "";
    },
    submitStatusModal: function() {
      // --- Do Something
      this.closeModal('status');
    },
    submitDeleteModal: function() {
      // --- Do Something
      this.closeModal('delete');
    }
  }
}
</script>
